import React, { createContext, useReducer, useRef } from "react";

import PropTypes from "prop-types";

const context = createContext("TabSwitcher");
const { Provider, Consumer } = context;

const reducer = (state, action) => {
  switch (action.type) {
    case "push":
      return [...state, action.step];
    case "back":
      return [...state.slice(0, -1)];
    case "replace":
      return [...state.slice(0, -1), action.step];
    case "reset":
      return [action.step];
    default:
      throw new Error();
  }
};
const TabPanel = ({ whenActive, children }) => (
  <Consumer>
    {({ activeTabId }) => (activeTabId === whenActive ? children : null)}
  </Consumer>
);

const TabSwitcher = ({ children, defaultStep }) => {
  // using `mutable ref object` is necessary because we are passing `defaultStep` into callback function `onReset`
  const defaultSteRef = useRef(defaultStep);
  defaultSteRef.current = defaultStep;

  const [state, dispatch] = useReducer(reducer, [defaultStep]);

  const onBack = () => state.length > 1 && dispatch({ type: "back" });
  const changeTab = (step, methode) =>
    dispatch({ type: methode === "replace" ? "replace" : "push", step });
  const onReset = () =>
    dispatch({ type: "reset", step: defaultSteRef.current });

  return (
    <Provider
      value={{
        activeTabId: state[state.length - 1],
        changeTab: changeTab,
        onBack,
        onReset,
      }}>
      {children}
    </Provider>
  );
};

const StepStore = (WrappedComponent) => {
  const Comp = (props) => (
    <Consumer>
      {(value) => <WrappedComponent {...props} step={value} />}
    </Consumer>
  );
  Comp.displayName = "Comp";
  return Comp;
};

TabPanel.propTypes = {
  whenActive: PropTypes.string,
  children: PropTypes.node,
};

TabPanel.defaultProps = {
  whenActive: "",
  children: <></>,
};

TabSwitcher.propTypes = {
  children: PropTypes.node,
  defaultStep: PropTypes.string,
};

TabSwitcher.defaultProps = {
  children: <></>,
};

export { TabPanel, TabSwitcher, StepStore, context as TabContext };
